import { connect } from 'react-redux'
import QuickAccessCard from '../../../components/quickAceesCard'
import { Section, SectionHeader, SectionTitle } from '../../../styled/sections'
import React from 'react'
import { Medical, ChevronRight, Building } from '../../../assets/icons'


const AppointmentsMobile = (props) => {
	return (
		<div style={{ width: '100%' }}>
			<Section>
				<SectionHeader gap="1rem">
					<SectionTitle mb="0">Programá tu turno</SectionTitle>
					<QuickAccessCard text="Ingresar a la guardia" leftIcon={<Medical color="#da1e28" />} righIcon={<ChevronRight />} urlRedirect={"/inicio/guardia"}/>
					<QuickAccessCard text="Turnos" leftIcon={<Building />} righIcon={<ChevronRight />} urlRedirect={"/inicio/turnos"}/>
				</SectionHeader>
			</Section>
		</div>
	)
}

export default connect()(AppointmentsMobile)